function isUnsafeCssUrl(value) {
  const v = (value || '').trim().toLowerCase();
  return (
    v.startsWith('http:')
    || v.startsWith('https:')
    || v.startsWith('//')
    || v.includes('blob.core.windows.net')
    || v.includes('.blob.')
  );
}

const PHOTO_SELECTOR_MARKERS = ['.mc-photo', 'figure.mc-photo', '[data-photo-slot]'];
const NONEMPTY_CONTENT = /content\s*:\s*['"]?(?!['"]\s*[;}])[^'"{};]+/i;

function isPhotoSlotSelector(selector) {
  const sl = (selector || '').toLowerCase();
  return PHOTO_SELECTOR_MARKERS.some((m) => sl.includes(m));
}

/** Remove :before slot labels and non-empty :after content on photo figures. */
export function stripPhotoSlotLabelsFromCss(css) {
  if (!css) return '';
  return css.replace(/([^{}]+)\{([^{}]*)\}/g, (match, selector, body) => {
    if (!isPhotoSlotSelector(selector)) return match;
    const sl = selector.toLowerCase();
    if (sl.includes(':before')) return '';
    if (sl.includes(':after') && NONEMPTY_CONTENT.test(body)) return '';
    return match;
  });
}

/** Remove off-origin url() / @import from CSS so html2canvas cannot taint via backgrounds. */
export function sanitizeCssForExport(css) {
  if (!css) return '';
  let out = css.replace(
    /@import\s+url\s*\(\s*([^)]+)\s*\)\s*;?/gi,
    (match, inner) => {
      const cleaned = inner.replace(/['"]/g, '').trim();
      return isUnsafeCssUrl(cleaned) ? '' : match;
    },
  );
  out = out.replace(/@import\s+[^;]+;/gi, (block) => (isUnsafeCssUrl(block) ? '' : block));
  out = out.replace(/url\s*\(\s*([^)]+)\s*\)/gi, (match, inner) => {
    const cleaned = inner.replace(/['"]/g, '').trim();
    return isUnsafeCssUrl(cleaned) ? 'none' : match;
  });
  out = out.replace(/@import\s+url\s*\(\s*none\s*\)\s*;?\s*/gi, '');
  out = out.replace(/source\s+sans\s+pro/gi, 'Source Sans 3');
  out = stripPhotoSlotLabelsFromCss(out);
  return out;
}

export function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Failed to read image for export'));
    reader.readAsDataURL(blob);
  });
}
